import { HOME_ID } from "template-store/constants/categories";
const ROOT_DIR = "templates";
export const getSolutionPageLink = (solutionId, solutionEnglishName)=>{
    const normalizedName = solutionEnglishName.replace(/ /g, "-").toLowerCase(); // replaceAll not supported in node 10
    return `/${ROOT_DIR}/template/${solutionId}/${normalizedName}`;
};
export const getSolutionCategoryPageLink = (categoryId)=>{
    if (categoryId === HOME_ID) return getSolutionsHomeLink();
    return `/${ROOT_DIR}/category/${categoryId}`;
};
export const getSolutionSearchLink = (searchTerm)=>{
    return `/${ROOT_DIR}/search?term=${searchTerm}`;
};
export const getSolutionsHomeLink = ()=>{
    return `/${ROOT_DIR}`;
};
